// extracted by mini-css-extract-plugin
export default {"label":"label---JtyD6","list":"list---HO80s","isEmptyMessage":"isEmptyMessage---JYABi"};